<template>
    <blockquote class="quote" v-html="quote" /> <!-- eslint-disable-line -->
</template>

<script>
export default {
    props: {
        quote: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="less">
.quote {
    .typography-headings();
    margin: var(--spacing-3xl) 0;
    display: inline-block;
    text-transform: none;
    font-size: var(--font-size-2xl);

    @media @q-md-min {
        font-size: var(--font-size-4xl);
    }

    &:before {
        .typography-headings();
        content: '“';
        display: inline-block;
        min-width: 2.125rem;
        transform: translateY(75%);
        color: var(--color-secondary);
        font-size: 3.5rem;
        line-height: .5;

        @media @q-md-min {
            width: 6.25rem;
            font-size: 6.5rem;
        }
    }
}
</style>
